import Service from "../Service";

const Reservation = {
  getReservation (id) {
    return Service.get(`api/reservation/${id}`)
  },
  createReservation (data) {
    return Service.post(`api/reservation`, data)
  },
  getReservationPaymentRequest (id, language) {
    return Service.get(`api/reservation/${id}/payment-request/${language}`)
  },
}

export default Reservation